import type { HTMLAttributes, ReactNode } from "react";

import { pathToAuthLogin } from "@/src/app/paths";
import { ButtonLink } from "@/src/components/ui/Button/ButtonLink";

export function LoginButton({
  className,
}: HTMLAttributes<HTMLAnchorElement>): ReactNode {
  return (
    <ButtonLink
      className={className}
      darkBackground
      href={pathToAuthLogin()}
      prefetch={false}
      size="medium"
    >
      Me connecter / adhérer
    </ButtonLink>
  );
}
